import { FC } from 'react'
import { SvgProps } from './svgProps'

const BestSellerIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 25}
    height={height || 26}
    viewBox="0 0 25 26"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            d="M0 0H25V25H0z"
            transform="translate(-263.000000, -108.000000) translate(263.000000, 108.000000)"
          />
          <g stroke={color || '#000'} strokeLinecap="round" strokeWidth="2">
            <path
              d="M10.833 12.522V6.25h0l.003-4.585c0-.92.746-1.665 1.666-1.665.92 0 1.665.745 1.665 1.665V9.77c0 .552.447 1 1 1 .28 0 .548-.118.737-.324l.774-.846c.658-.717 1.754-.815 2.528-.225.77.588.958 1.67.43 2.483l-4.224 6.505c-1.844 2.84-5 4.554-8.387 4.554h-.38c-3.463 0-6.324-2.7-6.524-6.157C.04 15.37 0 13.9 0 12.353c0-3.115.163-5.689.488-7.721C.647 3.644 1.5 2.917 2.5 2.917c.92 0 1.667.746 1.667 1.666v7.939c0 .81.657 1.468 1.468 1.468.066 0 .133-.004.198-.013 1.106-.15 2.228-.15 3.334 0 .803.11 1.544-.453 1.653-1.257.009-.066.013-.132.013-.198zM4.167 6.667L10.833 6.25M7.5 13.75L7.5 6.667"
              transform="translate(-263.000000, -108.000000) translate(263.000000, 108.000000) translate(3.333333, 1.250000)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default BestSellerIcon
